export default __webpack_public_path__ + "static/case_img3-29e8aed320a074bb5d00cfcddae6a6de.webp";